module.exports = __webpack_public_path__ + "static/media/miriam_perez2.cd62f003.jpg";